export const initialState = {
    pinMapModal: {open:false},
    userChoises: {},
    currentLocation: {},
    useTrigger: 0,
    updateAddress:{},
    secondNavbar: {show:false},
    categories:[],
    siteSettings:{},
    getAllBasket: [],
    step: null,
    openStatus: false,
    textStatus: null,
    navbarColor : false,
    userInfo:{fullName:''},
    authModal: {open:false,returnUrl:''},
    currentStage:0
}
